import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  ApiResponse,
  PaginatedResponse, 
} from "@/lib/types";
import {
  Blog,
  GetBlogsParams,
  CreateBlogRequest,
  UpdateBlogRequest
} from "@/types/blogTypes";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const blogApi = createApi({
  reducerPath: "blogApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: "include",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Blog"],
  endpoints: (builder) => ({
    createBlog: builder.mutation<ApiResponse<Blog>, CreateBlogRequest>({
      query: (data) => ({
        url: "/blog/create-blog",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Blog"],
    }),
    getAllBlogs: builder.query<PaginatedResponse<Blog>, GetBlogsParams | void>({
      query: (params) => ({
        url: "/blog",
        params: params || undefined,
      }),
      providesTags: ["Blog"],
    }),
    getBlogById: builder.query<ApiResponse<Blog>, string>({
      query: (id) => `/blog/${id}`,
      providesTags: ["Blog"],
    }),
    updateBlog: builder.mutation<ApiResponse<Blog>, UpdateBlogRequest>({
      query: ({ id, data }) => ({
        url: `/blog/update-blog/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Blog"],
    }),
    deleteBlog: builder.mutation<ApiResponse, string>({
      query: (id) => ({
        url: `/blog/delete-blog/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Blog"],
    }),
  }),
});

export const {
  useCreateBlogMutation,
  useGetAllBlogsQuery,
  useGetBlogByIdQuery,
  useUpdateBlogMutation,
  useDeleteBlogMutation,
} = blogApi;
